import { createAction } from '@reduxjs/toolkit';
import type { CreateCopyOfNonEditableFileModalProps } from 'reactApp/components/CreateCopyOfNoneditableFileModal/types';

export const focusOnCopiedFile = createAction<{ file: CreateCopyOfNonEditableFileModalProps['file']; home: string }>(
    'createCopyOfNoneEditableFile/focusOnCopiedFile'
);
